export default __webpack_public_path__ + "static/media/03_guessing.df99e9dc.mp3";